<script lang="ts">
  import Router from 'svelte-spa-router'
  import { routes } from './router/routes'
  import AppLayout from './layouts/AppLayout.svelte'
</script>

<AppLayout>
  <Router {routes} />
</AppLayout>
